import {Row, Col, Card} from 'react-bootstrap'

export interface FuturiskFreeHealthCheckupData {
  id?: number
  ID?: number
  Id?: number
  booking_reference?: string
  Name?: string
  name?: string
  Gender?: string
  gender?: string
  Age?: string | number
  age?: string | number
  phoneNumber?: string
  contactNumber?: string
  ContactNumber?: string
  emailId?: string
  EmailId?: string
  officialId?: string
  OfficialId?: string
  officialEmailId?: string
  OfficialEmailId?: string
  completeAddress?: string
  CompleteAddress?: string
  pincode?: string
  Pincode?: string
  homeCollectionDate?: string
  HomeCollectionDate?: string
  homeCollectionTime?: string
  HomeCollectionTime?: string
  status?: string
  createdAt?: string
  CreatedDateTime?: string
}

type Props = {
  requests: FuturiskFreeHealthCheckupData[]
}

const pickValue = (...values: Array<string | number | null | undefined>) => {
  const value = values.find((item) => item !== undefined && item !== null && String(item).trim() !== '')
  return value ?? '-'
}

const formatDate = (value?: string) => {
  if (!value) {
    return '-'
  }

  const parsedDate = new Date(value)
  if (Number.isNaN(parsedDate.getTime())) {
    return value
  }

  return parsedDate.toLocaleDateString('en-IN', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

const FuturiskFreeHealthCheckupList: React.FC<Props> = ({requests}) => {
  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <div>
          <h6 className='mb-1'>Your Free Health Checkup Booking</h6>
          <div className='text-muted small'>Only one booking is allowed per user.</div>
        </div>
        <span className='badge badge-light-success'>Booked</span>
      </div>

      <Row>
        {requests.map((request, index) => {
          const bookingId = request.id ?? request.ID ?? request.Id ?? request.booking_reference ?? index
          const bookingReference = request.booking_reference
          const bookingStatus = pickValue(request.status, 'Confirmed')
          const name = pickValue(request.Name, request.name)
          const gender = pickValue(request.Gender, request.gender)
          const age = pickValue(request.Age, request.age)
          const phoneNumber = pickValue(request.phoneNumber, request.contactNumber, request.ContactNumber)
          const emailId = pickValue(request.emailId, request.EmailId)
          const officialId = pickValue(
            request.officialEmailId,
            request.OfficialEmailId,
            request.officialId,
            request.OfficialId
          )
          const completeAddress = pickValue(request.completeAddress, request.CompleteAddress)
          const pincode = pickValue(request.pincode, request.Pincode)
          const collectionDate = formatDate(request.homeCollectionDate || request.HomeCollectionDate)
          const collectionTime = pickValue(request.homeCollectionTime, request.HomeCollectionTime)
          const createdAt = formatDate(request.createdAt || request.CreatedDateTime)

          return (
            <Col md={12} key={bookingId} className='mb-4'>
              <Card className='shadow-sm border-0' style={{borderLeft: '4px solid #0d6efd'}}>
                <Card.Header
                  className='text-white'
                  style={{background: 'linear-gradient(135deg, #0f766e 0%, #2563eb 100%)'}}
                >
                  <div className='d-flex justify-content-between align-items-center'>
                    <div>
                      <h5 className='mb-1'>Futurisk Free Health Checkup</h5>
                      <div className='small' style={{opacity: 0.9}}>
                        Home collection scheduled
                      </div>
                    </div>
                    <div className='text-end'>
                      <div className='badge bg-light text-dark mb-2'>{bookingStatus}</div>
                      {bookingReference && <div className='small'>#{bookingReference}</div>}
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={8}>
                      <div className='mb-4'>
                        <h6
                          className='text-muted mb-3'
                          style={{borderBottom: '2px solid #2563eb', paddingBottom: '8px', fontWeight: '600'}}
                        >
                          Booking Details
                        </h6>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Name:</span>
                          <span className='fw-semibold'>{name}</span>
                        </div>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Age:</span>
                          <span>{age}</span>
                        </div>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Gender:</span>
                          <span>{gender}</span>
                        </div>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Contact No.:</span>
                          <span>{phoneNumber}</span>
                        </div>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Email ID:</span>
                          <span className='text-break'>{emailId}</span>
                        </div>
                        <div className='d-flex align-items-start mb-2'>
                          <span style={{minWidth: '110px', color: '#6c757d'}}>Official Email:</span>
                          <span>{officialId}</span>
                        </div>
                      </div>

                      <div>
                        <h6
                          className='text-muted mb-3'
                          style={{borderBottom: '2px solid #0f766e', paddingBottom: '8px', fontWeight: '600'}}
                        >
                          Collection Address
                        </h6>
                        <div className='bg-light p-3 rounded'>
                          <p className='mb-2'>{completeAddress}</p>
                          <p className='mb-0'>Pincode: {pincode}</p>
                        </div>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div
                        className='p-4 text-center h-100'
                        style={{
                          background: 'linear-gradient(135deg, #0f766e 0%, #2563eb 100%)',
                          borderRadius: '12px',
                          color: 'white',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          minHeight: '200px',
                        }}
                      >
                        <div className='text-uppercase small mb-3' style={{letterSpacing: '1px', opacity: 0.85}}>
                          Home Collection
                        </div>
                        <div className='fs-3 fw-bold mb-2'>{collectionDate}</div>
                        <div
                          className='fs-4 fw-semibold mt-3 pt-3'
                          style={{borderTop: '1px solid rgba(255,255,255,0.35)'}}
                        >
                          {collectionTime}
                        </div>
                        <div className='small mt-4' style={{opacity: 0.85}}>
                          Booked on {createdAt}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export {FuturiskFreeHealthCheckupList}